const financialTradeReferencesFields = [
  {
    field: 'commands',
    title: 'Actions',
    cell: 'commands',
    locked: true,
    hidden: false,
    width: 100,
  },
  {
    field: 'name',
    title: 'Company Name',
    width: 300,
  },
  {
    field: 'contact',
    title: 'Contact',
    width: 150,
  },
  {
    field: 'terms',
    title: 'Terms',
    width: 150,
  },
  {
    field: 'creditLine',
    title: 'Credit Limit',
    width: 150,
  },
];

export default financialTradeReferencesFields;
